//https://netbasal.com/anchors-away-how-to-create-smooth-scrolling-in-angular-a657e0ea9699
import { Directive, HostListener, Input } from '@angular/core';
import { ScrollManagerDirective } from './scroll-manager.directive';

@Directive({
    selector: '[appScrollAnchor]',
    standalone: true
})
export class ScrollAnchorDirective {
   @Input('appScrollAnchor') id: string | number;

   constructor(private manager: ScrollManagerDirective) {}

   @HostListener('click')
   scroll() {
      this.manager.scroll(this.id);
   }
}
